import { IntegrationKey } from 'entities/Integrations'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { escapeHtml } from './escapeHtml'

type ICreateLabelField = {
  integrationKey: string
  connected: 'connected' | 'disconnected'
  mergeFieldKey: string
  fullMergeField?: string
  fallback?: string
  formattedFieldLabel?: string
}

const createLabelField = ({
  integrationKey,
  connected,
  mergeFieldKey,
  fullMergeField = '',
  fallback = '',
  formattedFieldLabel = '',
}: ICreateLabelField) => {
  // wrapSpan, rootSpan
  const rootSpan = document.createElement('span')
  const wrapSpan = document.createElement('span')

  wrapSpan.className = 'mergeField-wrap'
  wrapSpan.setAttribute('data-readonly', '')
  wrapSpan.setAttribute('contenteditable', 'false')

  // connectedSpan
  const connectedSpan = document.createElement('span')
  connectedSpan.className = `mergeField-integration-status mergeField-${connected}`
  connectedSpan.setAttribute('data-readonly', '')
  connectedSpan.setAttribute('data-connected', `${connected}`)
  connectedSpan.setAttribute('data-integration', `${integrationKey}`)
  connectedSpan.setAttribute('contenteditable', 'false')

  // contentSpan
  const contentSpan = document.createElement('span')
  contentSpan.className = `mergeField-content mergeField-${integrationKey}`
  contentSpan.setAttribute('data-readonly', '')
  contentSpan.setAttribute('data-key', `${fullMergeField}`)
  contentSpan.setAttribute('data-fallback', `${fallback}`)
  contentSpan.setAttribute('data-fieldname', `${mergeFieldKey}`)
  contentSpan.setAttribute('data-fieldlabel', `${formattedFieldLabel}`)
  contentSpan.setAttribute('contenteditable', 'false')
  contentSpan.innerHTML = escapeHtml(formattedFieldLabel || mergeFieldKey)

  wrapSpan.appendChild(contentSpan)

  if (integrationKey !== IntegrationKey.salesmessage) {
    wrapSpan.appendChild(connectedSpan)
  }

  rootSpan.appendChild(wrapSpan)

  return rootSpan.innerHTML
}

export const mergeFieldReplacer = (
  entities: IEntitiesStore,
  match: string,
  noMergeField?: boolean,
  isClearMergeField?: boolean
) => {
  const { mergeFieldStore, integrationsStore } = entities

  if (!mergeFieldStore.isMergeField(match)) return match
  if (noMergeField) return ''

  const { mergeField, fallback, mergeFieldKey, integrationKey, fullMergeField } =
    mergeFieldStore.getMergeFieldInfoByTemplate(match)

  const fieldLabel = mergeField?.label

  if (isClearMergeField) return fieldLabel || mergeFieldKey

  const integration = integrationsStore.getIntegration(integrationKey)
  const connected = integration?.isConnected ? 'connected' : 'disconnected'
  const formattedFieldLabel = fieldLabel || ''

  return createLabelField({
    integrationKey,
    connected,
    fullMergeField,
    fallback,
    mergeFieldKey,
    formattedFieldLabel,
  })
}
